/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "4893517f0984160ff0209724d132fbfd1b8cafeb";
